// NOTE: untitled-ui has a play circle 02 which is this element but the react
//       package doesn't provide it, yet. so we just copied it here.
export function PlayCircleIcon(props: { fill?: string; className?: string }) {
  const { fill = 'currentColor', className = '' } = props;
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.99998 14.6667C11.6819 14.6667 14.6666 11.6819 14.6666 8.00004C14.6666 4.31814 11.6819 1.33337 7.99998 1.33337C4.31808 1.33337 1.33331 4.31814 1.33331 8.00004C1.33331 11.6819 4.31808 14.6667 7.99998 14.6667Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33331 5.97678C6.33331 5.65859 6.33331 5.4995 6.39981 5.41068C6.45775 5.33328 6.54646 5.28485 6.6429 5.27797C6.75357 5.27006 6.8874 5.35609 7.15505 5.52816L10.3021 7.55127C10.5344 7.70058 10.6505 7.77523 10.6906 7.87016C10.7257 7.9531 10.7257 8.04669 10.6906 8.12964C10.6505 8.22456 10.5344 8.29922 10.3021 8.44853L7.15505 10.4716C6.8874 10.6437 6.75357 10.7297 6.6429 10.7218C6.54646 10.7149 6.45775 10.6665 6.39981 10.5891C6.33331 10.5003 6.33331 10.3412 6.33331 10.023V5.97678Z"
        fill={fill}
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
